// Pages for an integration and flow created from a layout (Routes.jsx: TradingPartnerDashboard and
// CompanySettingsTradingPartnerFlowConfigurationEdit; the created flows are v2 flow configurations).
export const integrationPath = (companyUUID, partnerUuid) =>
  `/c/${encodeURIComponent(companyUUID)}/tp/${encodeURIComponent(partnerUuid)}`

export const flowPath = (companyUUID, partnerUuid, flowUuid) =>
  `/c/${encodeURIComponent(companyUUID)}/settings/tp/${encodeURIComponent(partnerUuid)}/fc/${encodeURIComponent(flowUuid)}`

// A new Visual Builder (v3) flow in an integration, started with the AI flow builder (NewAiFlowPage).
export const newAiFlowPath = (companyUUID, partnerUuid) =>
  `/c/${encodeURIComponent(companyUUID)}/settings/tp/${encodeURIComponent(partnerUuid)}/fc/v3/new/ai`
